import { inject, NgModule, provideAppInitializer } from "@angular/core";
import { FlagsmithService } from "./services/flagsmith.service";
import { FlagsmithFeatureDirective } from "./directives/flagsmith-feature.directive";
import { FlagsmithFeatureGuard } from "./guards/flagsmith-feature.guard";
import { FlagsmithFeatureFlagNavigationResolver } from "./providers/flagsmith-feature-flag-navigation.resolver";

@NgModule({
    imports: [FlagsmithFeatureDirective],
    providers: [
        FlagsmithService,
        provideAppInitializer(() => inject(FlagsmithService).init()),
        FlagsmithFeatureGuard,
        FlagsmithFeatureFlagNavigationResolver
    ],
    exports: [FlagsmithFeatureDirective]
})
export class FlagsmithModule {}
